import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inventario/presentacionProducto';
import Presentacion from './presentacionProductoList';


const ms2p = (state) => {
  return {
    ...state.presentacionProducto,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Presentacion);
